import React, { useState, useEffect } from "react";
import { Skeleton } from "antd";
import NotFoundPage from "./NotFoundPage";
import ListFormComponent from "../components/ListFormComponent";
import ViewFormComponent from "../components/ViewFormComponent";
import EditFormComponent from "../components/EditFormComponent";
import {useParams} from "react-router-dom";

function EndpointPage(props) {
  const [method, setMethod] = useState(null);
  const [loaded, setLoaded] = useState(false);
  const [currentProject, setCurrentProject] = useState(false);
  const params = useParams();
  const setProjectId = (data) => {
    console.log(data)
    setCurrentProject(data.insertId)
  }
  useEffect(() => {
  }, [props])
  useEffect(() => {
    const actions = {
      list: "list",
      view: "view",
      new: "create",
      edit: "update",
      delete: "remove",
    };
    if (undefined === props.endpoints[params.namespace]) {
      setLoaded(true);
      return;
    }
    var action = "list";
    if (undefined !== params.action) {
      action = params.action;
    }
    var method = actions[action];
    if (undefined === props.endpoints[params.namespace][method]) {
      setLoaded(true);
      return;
    }
    setMethod(method);
    setLoaded(true);
  }, [props]);

  if (!loaded) {
    return (
      <>
        <Skeleton title active />
        <Skeleton title active />
        <Skeleton active />
      </>
    );
  }
  if (loaded && method) {
    return (
      <>
        {method === "list" && (
          <>
            <ListFormComponent
              home={props.home}
              create={
                props.endpoints[params.namespace].create
                  ? true
                  : false
              }
              endpoint={props.endpoints[params.namespace][method]}
              history={props.history}
            />
          </>
        )}
        {method === "view" && (
          <>
            <ViewFormComponent
              home={props.home}
              back={true}
              update={
                props.endpoints[params.namespace].update
                  ? true
                  : false
              }
              endpoint={props.endpoints[params.namespace][method]}
              id={params.id}
              history={props.history}
            />
          </>
        )}
        {method === "create" && (
          <>
            <EditFormComponent
              home={props.home}
              currentProject={props.currentProject}
              endpoints={props.endpoints}
              endpoint={props.endpoints[params.namespace][method]}
              history={props.history}
              onFinish={params.namespace === "projects" ? setProjectId : null}
            />
          </>
        )}
        {method === "update" && (
          <>
            <EditFormComponent
              home={props.home}
              currentProject={props.currentProject}
              remove={
                props.endpoints[params.namespace].remove
                  ? true
                  : false
              }
              endpoints={props.endpoints}
              endpoint={props.endpoints[params.namespace][method]}
              id={params.id}
              history={props.history}
            />
          </>
        )}
        {method === "remove" && (
          <>
            <ViewFormComponent
              home={props.home}
              endpoint={props.endpoints[params.namespace][method]}
              id={params.id}
              history={props.history}
              remove={true}
            />
          </>
        )}
      </>
    );
  }
  if (loaded && !method) {
    return (
      <>
        <NotFoundPage />
      </>
    );
  }
}

export default EndpointPage;
